import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenStatesEpic$ = createListenCollectionEpic({
  collection: 'states',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenStateDetailEpic$ = createListenDocEpic({
  collection: 'states',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
  ListenStatesEpic$,
  ListenStateDetailEpic$
};



// WEBPACK FOOTER //
// ./src/states/epics.ts